import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap'

import { periodChange, unReadNotifications } from '../../../features/site/siteSlice'
import history from '../../../history'
import { serviceMap } from '../../utils/common'
import { INSIGHT_PENDING } from '../../utils/Recommendations'

function TaskListCard({recommendations}){
    const dispatch = useDispatch()

    const user = useSelector(state => state.session.user)
    const model = useSelector(state => state.site.model)
    const unReadMessages = useSelector(unReadNotifications)

    const site = model?.sites?.length > 0 ? model?.sites[model?.siteActiveIdx] : {}

    let itemGrouping = {
        [INSIGHT_PENDING]: 0
    }
    recommendations?.items?.forEach(item => {
        if(itemGrouping[item.status] === undefined){
            itemGrouping[item.status] = 0
        }
        
        if(item.status === undefined){
            itemGrouping[INSIGHT_PENDING] ++
        } else {
            itemGrouping[item.status] ++
        }
    })

    let listItems = []
    let servicesToClaim = 0

    if(unReadMessages > 0){
        listItems.push({
            title: `You have ${unReadMessages} unread notifications`,
            link: "/notifications"
        })
    }

    if(itemGrouping[INSIGHT_PENDING] > 0){
        listItems.push({
            title: `You have ${itemGrouping[INSIGHT_PENDING]} pending insights`,
            link: "/audits"
        })
    }

    Object.keys(serviceMap).forEach(service => {
        if(!site?.attr?.accounts || !site?.attr?.accounts[service]){
            listItems.push({
                title: `Claim your ${serviceMap[service].titleUnformatted} account`,
                link: `/admin/${site.siteId}/${service}`
            })
            servicesToClaim ++
        }
    })

    const buttonList = () => <>
        <Link to="/notifications" className="btn btn-outline-light btn-lg btn-block">
            <i className="fa fa-bell"></i> Notifications <span className="badge badge-warning text-black">{unReadMessages}</span>
        </Link><br />
        <Link to="/audits" className="btn btn-outline-light btn-lg btn-block">
            <i class="fas fa-lightbulb"></i> Insights <span className="badge badge-warning text-black">{itemGrouping[INSIGHT_PENDING]}</span>
        </Link><br />
        <Link to="/admin" className="btn btn-outline-light btn-lg btn-block" id="claimServiceBtn">
            <i class="fas fa-toolbox"></i> Claim Services <span className="badge badge-warning text-black">{servicesToClaim}</span>
        </Link>
    </>

    const ListItem = ({title, link}) => {
        return <li>
            <Link to={link} className="text-light">
                <i class="far fa-list-alt fa-1-5 mr-1"></i><span class="h5">
                    {title}
                </span>
            </Link>
        </li>
    }

    return <Card color="dark" className="text-light" style={{
        backgroundImage: "url(/images/blue-bk-hex.png)",
        backgroundPosition: "50% 50%",
        backgroundSize: "cover",
        minHeight: "294px"
    }} body>
        {listItems.length > 0 && <h3 className="text-light">Please review &amp; address these items:</h3>}
        <div className="d-flex justify-content-between">
            <ul class="list-unstyled mb-2 mb-sm-0 mr-md-2" style={{lineHeight: "30px"}}>
                {listItems.map(listItem => <li>
                    <ListItem {...listItem} />
                </li>)}
            </ul>
            <div className="d-none d-sm-block">
                {buttonList()}
            </div>
        </div>
        <div className="d-block d-sm-none">
            {buttonList()}
        </div>
    </Card>
}

TaskListCard.defaultProps = {
    recommendations: []
}

export default TaskListCard